import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint, PdfBrush } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/image';
import '../../pdf/draw/label';

/**
 * Pocitani (Counting) - Count images scattered on a page
 *
 * Layout: 2 portrait pages. Top area: randomly placed images (non-overlapping).
 * Bottom: legend row showing each image with an empty box for writing the count.
 *
 * Migrated from C# EduFrame.Img10.Generators.Pocitani
 */
export class PocitaniKusu implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 2;
  }
  countMax(): number {
    return 12;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const margin = PdfUnit.FromMillimeters(15);
    const imageW = (PdfSize.A4.width - 2 * margin) / opts.list.length;
    const imageSize = { width: imageW, height: imageW };
    const textSize = { width: imageW, height: PdfUnit.FromMillimeters(20) };

    const rect = new PdfRect(
      margin,
      margin,
      PdfSize.A4.width - 2 * margin,
      PdfSize.A4.height - 2 * margin - imageSize.height - textSize.height
    );

    const allLeftTexts = opts.list.map((item) => item.left.getText() ?? '');

    for (let p = 0; p < 1; p++) {
      const page = pdf.addPage();

      const legendFont = page.adjustFontMulti(
        allLeftTexts.map((t) => [t]),
        GUtil.baseFont,
        new PdfSize(imageSize.width, imageSize.height)
      );

      page.drawRectangle(GUtil.basePen, null, rect);

      const placed: PdfRect[] = [];
      let misplaced = 0;

      while (misplaced < 100) {
        const s = PdfUnit.FromMillimeters(15 + opts.data.random.nextDouble() * 20);
        const x = rect.x + opts.data.random.nextDouble() * (rect.width - s);
        const y = rect.y + opts.data.random.nextDouble() * (rect.height - s);
        const r = new PdfRect(x, y, s, s);

        const overlaps = placed.some(
          (existing) =>
            !(
              r.right < existing.x ||
              r.x > existing.right ||
              r.bottom < existing.y ||
              r.y > existing.bottom
            )
        );

        if (overlaps) {
          misplaced++;
        } else {
          misplaced = 0;
          placed.push(r);

          const img = opts.data.random.next(0, opts.list.length);
          if (img < opts.list.length) {
            page.drawLabel(opts.list[img].left, { rect: r });
          }
        }
      }

      // Legend row at bottom
      for (let i = 0; i < opts.list.length; i++) {
        const r1 = new PdfRect(
          rect.x + i * imageSize.width,
          rect.bottom,
          imageSize.width,
          imageSize.height
        );
        const r2 = new PdfRect(
          rect.x + i * imageSize.width,
          r1.bottom,
          textSize.width,
          textSize.height
        );

        page.drawLabel(opts.list[i].left, { rect: r1, font: legendFont });

        page.drawRectangle(GUtil.basePen, null, r1);
        page.drawRectangle(GUtil.basePen, null, r2);
      }
    }
  }
}
